import React from 'react';
import PropTypes from 'prop-types';

import { cartItemsArrayPropTypes } from 'helpers/propTypes';

import Breadcrumb from 'components/commons/Breadcrumb';
import Loading from 'components/commons/Loading';
import CartSummary from 'components/commons/CartSummary';
import Benefit from 'components/commons/Benefit';
import CheckoutMobileSummaryBar from './CheckoutMobileSummaryBar';

import './Checkout.scss';

const Checkout = (props) => {
  const {
    cartSize, items, loading, minimumPurchase, renderForm, shippingText, subtotal,
    url, urlText, coupon, subTotEnv, cuotasMP, onOpenPaymentModal, showMPButton, client,
    paymentMethods,
  } = props;

  const showCart = cartSize > 0;

  let marginStyle = '';
  switch (client?.design) {
    case 4:
      marginStyle = 'neo';
      break;
    case 5:
      marginStyle = 'd5';
      break;
    case 6:
      marginStyle = 'man';
      break;
    default:
      marginStyle = '';
  }

  const shippingAmount = !!subTotEnv ? subTotEnv : 0;

  const renderSummary = () => (
    <CartSummary
      items={items}
      shippingText={shippingText}
      subtotal={subtotal}
      coupon={coupon}
      subTotEnv={shippingAmount}
      cuotasMP={cuotasMP}
      onOpenPaymentModal={onOpenPaymentModal}
      showMPButton={showMPButton}
      paymentMethods={paymentMethods}
    />
  );

  return (
    <div className={`checkout-page ${marginStyle}`} data-testid="checkout-page">
      <div className="container checkout-shell">
        <Breadcrumb urls={['/carrito', url]} names={['Carrito', urlText]} />

        <header className="checkout-hero">
          <div>
            <span className="checkout-eyebrow">Compra segura</span>
            <h1>Finalizá tu pedido</h1>
            <p>Completá tus datos, elegí envío y confirmá el medio de pago.</p>
          </div>
          <div className="checkout-steps" aria-label="Pasos del checkout">
            <span className="checkout-step-pill is-active">1. Datos</span>
            <span className="checkout-step-pill is-active">2. Envío y pago</span>
            <span className="checkout-step-pill">3. Confirmación</span>
          </div>
        </header>

        {loading && <Loading size={80} />}
        {!loading && (
          showCart ? (
            <>
              <div className="checkout-layout">
                <main className="checkout-flow">
                  {renderForm()}
                </main>
                <aside className="checkout-cart-summary d-none d-md-block">
                  {renderSummary()}
                </aside>
              </div>

              <CheckoutMobileSummaryBar
                subtotal={subtotal}
                shippingText={shippingText}
                coupon={coupon}
                subTotEnv={shippingAmount}
                paymentMethods={paymentMethods}
              >
                {renderSummary()}
              </CheckoutMobileSummaryBar>

              <h4 className="minimum-purchase" data-testid="minimum-purchase">
                {`Compra mínima: $${minimumPurchase}`}
              </h4>
            </>
          ) : (
            <div className="checkout-empty">
              <h2 className="text-center" data-testid="empty-cart">
                El carrito está vacío
              </h2>
            </div>
          )
        )}
      </div>
      <div className="section">
        <Benefit minimumPurchase={minimumPurchase} />
      </div>
    </div>
  );
};

Checkout.defaultProps = {
  coupon: null,
};

Checkout.propTypes = {
  cartSize: PropTypes.number.isRequired,
  coupon: PropTypes.shape({
    id: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired,
  }),
  items: cartItemsArrayPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  minimumPurchase: PropTypes.number.isRequired,
  renderForm: PropTypes.func.isRequired,
  shippingText: PropTypes.string.isRequired,
  subtotal: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  urlText: PropTypes.string.isRequired,
};

export default Checkout;
